/**
 * Vehicle category used by the Sourcing filters.
 * `null` / `undefined` in `FiltersType.vehicleCategory` means "all categories" (today's behaviour).
 *
 * A const object rather than an `enum` so the values stay plain string literals and round-trip
 * through the API types (`SourcingVehicleCategory` in `@dms/api/core`) without a cast.
 */
export const VehicleCategoryFilter = {
  CAR: 'CAR',
  VAN: 'VAN',
} as const;

export type VehicleCategoryFilter =
  (typeof VehicleCategoryFilter)[keyof typeof VehicleCategoryFilter];
